// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","834":"94726e6d"}[chunkId] || chunkId) + "-" + {"293":"8dd6482ae80b891baa8e","454":"fdadc382e9b8610cf81a","834":"aa0feeb4ea5a0c479a26"}[chunkId] + ".js";
};